var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 40,
    letterSpacing: -1,
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "T")), /*#__PURE__*/React.createElement("text", {
    fontSize: 15,
    letterSpacing: -0.375,
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 38
  }, "T"))), /*#__PURE__*/React.createElement("path", {
    d: "M-20-25h78v78h-78z"
  }))));
}
export default SvgParagraph;